<template>
    <div class="menu">
        <img src="../assets/logo-1.png" class="logo">
        <div class="menu-box">
            <div :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">Home </div>
             <div :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">Company Profile</div>
             <div :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">Privacy Policy</div>
             <div :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">Join the team</div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Menu",
    props: {
        step: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            index: 0
        };
    },
    methods: {
        selectMenu(value) {
            this.index = value
            if (value == this.step) {
                return
            }
            switch (value) {
                case 1: this.$router.push({ path: "/" }); break;
                case 2: this.$router.push({ path: "CompanyProfile" }); break;
                case 3: this.$router.push({ path: "Privacy" }); break;
                case 4: this.$router.push({ path: "Team" }); break;
                // case 5: this.$router.push({ path: "aboutUs" }); break;
                // case 5: this.$router.push({ path: "cooperate" }); break;
                default: this.$router.push({ path: "/" }); break;
            }
        }
    }
}
</script>
<style lang="less" scoped>
.menu {
    padding: 10px 360px;
    background: linear-gradient(90deg, #F7964F 0%, #F65A52 100%);
    ;
    display: flex;
    justify-content: space-between;

    .logo {
        width: 187px;
        height: 48px;
    }

    .menu-box {
        display: flex;
        width: 600px;
        line-height: 56px;
        justify-content: space-between;
        font-size: 18px;
        font-weight: 500;
        color: #fff;
        cursor: pointer;
    }

    .select {
        color: #F33C02;
        background: #FFFFFF;
        border-radius: 24px;
        padding: 0px 20px;
    }
}
</style>